const COMPONENT_NAME = "ProductSwatch";
const MAX_COMPACT_COUNT = 4;
const SWATCH_BUTTON_TEST_ID_PREFIX = "swatchTestId_";
const SWATCH_ICON_TEST_ID_PREFIX = "swatchIconTestId_";
const SWATCH_OVERFLOW_COUNTER_TEST_ID = "swatchOverflowCounterTestId";
const SWATCH_SIZE_FULL = "2.5rem";
const SWATCH_SIZE_COMPACT = "1.5rem";
export {
  COMPONENT_NAME,
  MAX_COMPACT_COUNT,
  SWATCH_BUTTON_TEST_ID_PREFIX,
  SWATCH_ICON_TEST_ID_PREFIX,
  SWATCH_OVERFLOW_COUNTER_TEST_ID,
  SWATCH_SIZE_COMPACT,
  SWATCH_SIZE_FULL
};
